<template>
  <div
    class="dt-page-status-list ut-flex"
    style="height: 100%; min-height: 35px"
  >
    <div
      class="dt-page-status ut-flex"
      v-for="invs of statusTV"
      :key="invs.key"
    >
      <div
        class="circle"
        :style="{
          backgroundColor: detectColorValue(invs.value)
            ? invs.value
            : `#${invs.value}`,
        }"
      ></div>
      <div class="status-name">{{ invs.text }}</div>
    </div>
  </div>
</template>
<script>
import { getInvoiceStatusColor } from "../../modules/accounting/models/color-status";
import { detectColorValue } from "../../utility";

export default {
  props: {
    statusTV: {
      type: Array,
    },
  },
  components: {},
  data: function () {
    return {};
  },
  computed: {},

  methods: {
    getInvoiceStatusColor: getInvoiceStatusColor,
    detectColorValue: detectColorValue,
  },
};
</script>
<style lang="scss">
.dt-page-status-list {
  // display: flex;
  .dt-page-status {
    // margin-top: 15px;
    // display: flex;
    margin-left: 15px;
    // max-width: 150px;
    //flex: 1;
    &:first-child {
      margin-left: 0px;
    }
    .circle {
      width: 15px;
      height: 15px;
      border-radius: 30px;
      margin-right: 10px;
      // margin-top: 2.5px;
    }
    .status-name {
      flex: 1;
      width: max-content;
    }
  }
}
</style>
